import styled from 'styled-components';

export const FormatLabelStyled = styled.div`
  display: flex;
  align-items: center;

  div {
    display: flex;
    align-items: center;
    margin-right: 4px;
  }
`;
